import PropTypes from 'prop-types';

export default function RadioIcon({ selected = false }) {
  if (selected) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
        style={{ flexShrink: 0, marginTop: 2 }}
      >
        <path
          d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
          style={{ fill: 'var(--dds-palette-primary-600)' }}
        />
        <circle
          cx="10"
          cy="10"
          r="4"
          style={{ fill: 'var(--dds-palette-default-white)' }}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0, marginTop: 2 }}
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        style={{
          stroke: 'var(--dds-palette-gray-200)',
          strokeWidth: 1,
          fill: 'var(--dds-palette-default-white)',
        }}
      />
    </svg>
  );
}

RadioIcon.propTypes = {
  selected: PropTypes.bool,
};
